module.exports = __webpack_public_path__ + "static/media/48.18ca3568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/48.jpg
// module id = 738
// module chunks = 0